/**
 * VF Loyalty info Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var i18n = require('i18n');
    var BaseReplacerView = require('common/base.replacer.view');
    var LoyaltyInfoModel = require('replacers/bingo-replacers/loyalty-info.model');

    module.exports = BaseReplacerView.extend({

        model: new LoyaltyInfoModel(),

        tagName: 'span',

        className: 'val_type_loyalty_info',

        accessRules: {
            allow: ['user']
        },

        initialize: function(options) {
            this.options = options || {};

            // prevent possible fuck up with binding wrong render when checkAccess() is set to false
            this.checkAccess() && this.model.fetch({
                isCacheable: this.options.isCacheable || false,
                success: this._handleSuccess.bind(this),
                error: this._handleError.bind(this)
            });
        },

        subscribe: function() {
            this.model.on('change', this._handleSuccess.bind(this));
        },

        _handleSuccess: function() {
            var response = this.model.toJSON();
            this.render(response.data);
        },

        _handleError: function(model, response) {
            // 89521, 89525
            var tKey = 'playtech.mobile.system.loyaltyRedeem.info.fetchError.' + response.ID;
            this.showInfo({ content: this.translate(tKey), variant: this.toastVariants.ERROR });
        },

        render: function(data) {
            var outputHtml;
            var strategy = data ? this.options.name : 'LOADING';

            switch (strategy) {
                case 'VF_LOYALTY_LEVEL':
                    outputHtml = i18n.translateExt(
                        'playtech.mobile.system.loyaltyRedeem.value.loyaltyLevelName.' + data.points.levelName,
                        data.points.levelName
                    );
                    break;

                case 'VF_LOYALTY_POINTS_TOTAL':
                    outputHtml = data.points.balance;
                    break;

                case 'VF_LOYALTY_POINTS_IN_PERIOD':
                    outputHtml = data.points.earnedInPeriod;
                    break;

                case 'VF_LOYALTY_POINTS_MIN':
                    outputHtml = data.minBonusBalance;
                    break;

                default:
                    outputHtml = this.translate('playtech.mobile.system.loyaltyRedeem.info.loading');
            }

            this.$el.html(outputHtml);

            return this;
        }

    }, {
        nameOfReplacers: [
            'VF_LOYALTY_LEVEL',
            'VF_LOYALTY_POINTS_TOTAL',
            'VF_LOYALTY_POINTS_IN_PERIOD',
            'VF_LOYALTY_POINTS_MIN'
        ]
    });
});
